import type { CatalogTree } from '../types';

// Login and password reset (admin panel screens §3.1). The error texts that tr.ts already holds
// come from ApiError.message; only account_closed is worded differently here.
export const access = {
  login: {
    email: 'E-posta',
    password: 'Şifre',
    submit: 'Giriş yap',
    forgot: 'Şifremi unuttum',
    code: 'Doğrulama kodu',
    recoveryCode: 'Kurtarma kodu',
    verify: 'Doğrula',
    useRecoveryCode: 'Kurtarma kodu kullan',
    retry: 'Tekrar dene',
    accountClosed: 'Bu hesap devre dışı bırakılmış.',
    enrolment: {
      qrLabel: 'Doğrulama uygulaması için QR kodu',
      secret: 'Gizli anahtar',
      note: 'Kodu doğrulayınca hesabınız etkinleşir.',
    },
    recoveryCodes: {
      title: 'Kurtarma kodları',
      description: 'Bu kodlar yalnızca bir kez gösterilir.',
      saved: 'Kodları kaydettim',
      continue: 'Devam et',
    },
  },
  passwordReset: {
    email: 'E-posta',
    send: 'Bağlantı gönder',
    sent: 'E-posta adresiniz kayıtlıysa bir bağlantı gönderdik.',
    newPassword: 'Yeni şifre',
    newPasswordAgain: 'Yeni şifre (tekrar)',
    hint: 'En az 10 karakter.',
    mismatch: 'Şifreler aynı değil.',
    save: 'Şifreyi kaydet',
    saved: 'Şifreniz kaydedildi.',
    toLogin: 'Giriş sayfasına dön',
    requestNew: 'Yeni bağlantı iste',
  },
} as const satisfies CatalogTree;
